'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.breakpoints = void 0;
exports.breakpoints = { lg: 1200, md: 992, sm: 768, xs: 576 };
const defaultConfig = {
  flex: {
    dir: 'row',
    on: false,
  },
  grid: {
    cols: 2,
    on: false,
  },
  positioning: {
    align: 'center',
    bottom: 0,
    justify: 'space-between',
    top: 0,
  },
  sizing: {
    default: 'lg',
    sizes: {
      lg: 1410,
      md: 1170,
      none: 0,
      sm: 930,
      xl: 1920,
      xs: 690,
    },
  },
  spacing: {
    colGap: 1,
    padding: 2.5,
    rowGap: 1,
  },
};
exports.default = defaultConfig;
//# sourceMappingURL=config.js.map
